import styled from "styled-components";

export default styled.div`

&{
  .label{
    display: flex;
    justify-content: center;
    align-items:center;
    margin:0;
    width:200px;
    height: 30px;
    cursor: pointer;
    color: white;
    font-size: ${props => props.theme.spacing.spacing_05};//16px;
    box-shadow: 1px 1px 5px #555;
    border-radius: 5px;
    background-color: ${props => props.theme.colors.green};
  }
  input[type=file] {
    display: none;
}
}
`
